import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupportAttachmentResponse } from 'src/app/models/support-attachment-response.model';
import { SupportChatCreate } from 'src/app/models/support-chat.model';
import { createHttpParams } from 'src/app/shared/utils/create-http-params.utils';
import { SupportResponse } from '../../../models/support-response.model';
import { BaseService } from '../../base/base.service';
import { Reply } from './../../../models/replay.model';
import { SupportMessage } from './../../../models/support-messages.model';
import { SupportReplayCreate } from './../../../models/support-replay-create.model';

@Injectable({
  providedIn: 'root'
})
export class SupportChatService extends BaseService<SupportResponse> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(false);
  constructor(protected http: HttpClient) {
    super(http, 'support');
  }

  newMessage(newMessage: FormData) {
    return this.http.post(`${this.resourceUrl}`, newMessage, {
      observe: 'response'
    });
  }

  retrieveSupportMessageById(
    id: number | string | undefined
  ): Observable<HttpResponse<SupportMessage>> {
    return this.http.get<SupportMessage>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }

  createSupportMessage(
    entity: SupportChatCreate
  ): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.resourceUrl}`, entity, {
      observe: 'response'
    });
  }

  createSupportReplay(
    id: number | string | undefined,
    entity: SupportReplayCreate
  ): Observable<HttpResponse<Reply>> {
    return this.http.post<Reply>(`${this.resourceUrl}/${id}/reply`, entity, {
      observe: 'response'
    });
  }

  downloadAttachment(id: number) {
    return this.http.get<{ data: string }>(
      `${this.resourceUrl}/${id}/attachment`
    );
  }

  archiveDocumentsList(
    searchValues: string
  ): Observable<HttpResponse<{ data: SupportAttachmentResponse[] }>> {
    const params = createHttpParams({ fileName: searchValues });
    return this.http.get<{ data: SupportAttachmentResponse[] }>(
      `${this.resourceUrl}/attachments`,
      {
        params,
        observe: 'response'
      }
    );
  }

  countUnreadMessages() {
    this.http
      .get<{ data: number }>(`${this.resourceUrl}/messages/unread-count`, {
        observe: 'response'
      })
      .subscribe(() => {});
  }
}
